<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="Page_iv"></a><a id="ch003_copyright"></a><span class="small">NEW YORK UNIVERSITY PRESS</span><br/>New York and London<br/><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="copyright">© 2008 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>Hegarty, Marilyn E.<br/>Victory girls, khaki-wackies, and patriotutes : the regulation of female sexuality during World War II / Marilyn E. Hegarty.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN-13: 978-0-8147-3704-0 (cloth : alk. paper)<br/>ISBN-10: 0-8147-3704-8 (cloth : alk. paper)<br/>1. Women—Sexual behavior—United States—History. 2. World War, 1939–1945—Women—United States. 3. Soldiers—Sexual behavior—United States. 4. Sexual ethics for women—United States—History. I. Title.<br/>HQ18.U5H42  2007<br/>306.7082’097309044—dc22                  2007027210</p>
<p class="copyright">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability.</p>
<p class="copyright">Manufactured in the United States of America<br/>10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003_copyright.vue?c9974912